export const meta: BlockMeta = {
  title: "Spacer",
  tags: ["subpage"],
}

import { cn } from "@utils/tw"
import { defineBlock, EditableText, InnerBlocks } from "eddev/blocks"

interface SpaceType {
  [key: string]: string
}

export default defineBlock("content/spacer", (props) => {
  const SPACING: SpaceType = {
    1: "h-1",
    2: "h-2",
    3: "h-3",
    4: "h-4",
    5: "h-5",
    6: "h-6",
    7: "h-7",
    8: "h-8",
    9: "h-9",
    10: "h-10",
    11: "h-11",
    12: "h-12",
  }
  const space = props.size || "4"

  return (
    <div
      className={cn(
        "w-full",
        SPACING[space],
        env.admin && "border-dashed border-black bg-grey6 flex justify-center items-center",
      )}
    >
      {env.admin && <span>SPACER</span>}
    </div>
  )
})
